// extracted by mini-css-extract-plugin
export default {"paymentRadio":"PaymentRadio_paymentRadio__fEDXh","selected":"PaymentRadio_selected__4FsLI"};